<div
    class="timeline-container"
    [style.--timeline-color]="block.data?.color || 'var(--color-primary)'"
    role="list"
    [attr.aria-label]="block.data?.title || 'Timeline'">
    @for (item of block.content; track $index) {
        <div class="timeline-item" role="listitem">
            <div class="timeline-left">
                <div class="timeline-icon-wrapper" aria-hidden="true">
                    @if (item.data.image) {
                        <img [src]="getIconUrl(item.data.image_url)" class="timeline-icon" alt="" />
                    }
                    @if (block.data?.showNumbers === 1 || block.data?.showNumbers === '1') {
                        <div class="timeline-number">{{ $index + 1 }}</div>
                    }
                </div>
                @if (!$last) {
                    <div class="timeline-connector" aria-hidden="true"></div>
                }
            </div>
            <div class="timeline-content">
                <h4 class="timeline-title" [innerHTML]="item.data.title"></h4>
                <div class="timeline-description" [innerHTML]="item.data.description"></div>
            </div>
        </div>
    }
</div>
